import {TermsAndConditionsModel} from "src/app/models/common/terms-and-conditions.model";
import {
    ContainerCondition,
    ContainerSizeType,
    CreatedBy,
    EmptyRepoQuoteChargeMaster, EmptyRepoQuoteChargeMasterError, IBaseQuoteItem,
    IContainerCondition,
    IContainerSizeType,
    IDropoffSchedule,
    IEro,
    ILeaseAgreement,
    ILeaseQuoteItemModel,
    ILeaseQuoteModel,
    IPickupSchedule,
    LeasePurpose,
    LocationModel,
    QuoteChargeMaster,
    QuoteChargeMasterError,
    UploadedDocument
} from "../base-quote.model";

export class PickupScheduleError {
    id: string[];
    port: string[];
    client_id: string[];
    is_active: string[];
    per_month_permitted_quantity: string[];
    total_permitted_quantity: string[];
    handling_charge_currency: string[];
    handling_charge: string[];
    remarks: string[];
    pickup_charge_currency: string[];
    pickup_charge: string[];
    requirement: string[];

    constructor() {
        this.id = [];
        this.port = [];
        this.client_id = [];
        this.is_active = [];
        this.per_month_permitted_quantity = [];
        this.total_permitted_quantity = [];
        this.handling_charge_currency = [];
        this.handling_charge = [];
        this.remarks = [];
        this.pickup_charge_currency = [];
        this.pickup_charge = [];
        this.requirement = [];
    }
}

export class DropoffScheduleError {
    id: string[];
    port: string[];
    client_id: string[];
    is_active: string[];
    per_month_permitted_quantity: string[];
    total_permitted_quantity: string[];
    handling_charge_currency: string[];
    handling_charge: string[];
    remarks: string[];
    dropoff_charge_currency: string[];
    dropoff_charge: string[];
    requirement: string[];

    constructor() {
        this.id = [];
        this.port = [];
        this.client_id = [];
        this.is_active = [];
        this.per_month_permitted_quantity = [];
        this.total_permitted_quantity = [];
        this.handling_charge_currency = [];
        this.handling_charge = [];
        this.remarks = [];
        this.dropoff_charge_currency = [];
        this.dropoff_charge = [];
        this.requirement = [];
    }
}

export class LeaseAgreementError {
    id: string[];
    terms_and_condition_fk: string[];
    lease_purpose: string[];
    documents: string[];
    is_active: string[];
    terms_and_condition_text: string[];
    lease_type: string[];
    billing_cycle: string[];
    billing_date: string[];
    security_deposit_currency: string[];
    security_deposit: string[];
    agreement_number: string[];
    agreement_starts_from: string[];
    agreement_ends_on: string[];
    currency: string[];
    remarks: string[];
    lessor_company_name: string[];
    lessor_contact_person_name: string[];
    lessor_contact_person_email: string[];
    lessor_contact_person_phone: string[];
    lessee_company_name: string[];
    lessee_contact_person_name: string[];
    lessee_contact_person_email: string[];
    lessee_contact_person_phone: string[];
    lessor_company_address: string[];
    lessee_company_address: string[];
    request: string[];
    lease_agreement_duration: string[]

    constructor() {
        this.id = [];
        this.terms_and_condition_fk = [];
        this.lease_purpose = [];
        this.documents = [];
        this.is_active = [];
        this.terms_and_condition_text = [];
        this.lease_type = [];
        this.billing_cycle = [];
        this.billing_date = [];
        this.security_deposit_currency = [];
        this.security_deposit = [];
        this.agreement_number = [];
        this.agreement_starts_from = [];
        this.agreement_ends_on = [];
        this.currency = [];
        this.remarks = [];
        this.lessor_company_name = [];
        this.lessor_contact_person_name = [];
        this.lessor_contact_person_email = [];
        this.lessor_contact_person_phone = [];
        this.lessee_company_name = [];
        this.lessee_contact_person_name = [];
        this.lessee_contact_person_email = [];
        this.lessee_contact_person_phone = [];
        this.lessor_company_address = [];
        this.lessee_company_address = [];
        this.request = [];
        this.lease_agreement_duration = [];
    }
}

export class EroError {
    id: string[];
    is_active: string[];
    amount_currency: string[];
    amount: string[];
    days: string[];
    sequence_no: string[];
    penalty_from: string[];

    constructor() {
        this.id = [];
        this.is_active = [];
        this.amount_currency = [];
        this.amount = [];
        this.days = [];
        this.sequence_no = [];
        this.penalty_from = [];
    }
}

export class LeaseQuoteItemError {
    id: string[];
    requirement: string[];
    quantity: string[];
    is_ero_enabled: EarlyReturnOptions[];
    ero: EroError[];
    updated_at: string[];
    is_active: string[];
    per_diem_charge: string[];
    build_up_period_days: string[];
    build_down_period_days: string[];
    post_build_down_per_diem_charge: string[];
    minimum_rental_period_days: string[];
    container_deemed_lost_after_days: string[];
    notice_period_amendment_delivery_days: string[];
    notice_period_amendment_return_days: string[];
    leasing_period_days: string[];
    created_by: string[];
    quote: string[];
    container_size_type: string[];
    container_condition: string[];
    pol_list: string[];
    pod_list: string[];
    drv_new_build_price: string[];
    drv_new_build_price_currency: string[];
    drv_max_depreciation_price: string[];
    drv_max_depreciation_price_currency: string[];
    drv_max_depreciation_percent: string[];
    drv_depreciation_per_year: string[];
    drv_max_depreciation_unit: string[];
    ad_hoc_charges: QuoteChargeMasterError[];

    constructor() {
        this.id = [];
        this.requirement = [];
        this.quantity = [];
        this.is_ero_enabled = [];
        this.ero = [new EroError()];
        this.updated_at = [];
        this.is_active = [];
        this.per_diem_charge = [];
        this.build_up_period_days = [];
        this.build_down_period_days = [];
        this.post_build_down_per_diem_charge = [];
        this.minimum_rental_period_days = [];
        this.container_deemed_lost_after_days = [];
        this.notice_period_amendment_delivery_days = [];
        this.notice_period_amendment_return_days = [];
        this.leasing_period_days = [];
        this.created_by = [];
        this.quote = [];
        this.container_size_type = [];
        this.container_condition = [];
        this.pol_list = [];
        this.pod_list = [];
        this.drv_new_build_price = [];
        this.drv_new_build_price_currency = [];
        this.drv_max_depreciation_price = [];
        this.drv_max_depreciation_price_currency = [];
        this.drv_max_depreciation_percent = [];
        this.drv_depreciation_per_year = [];
        this.drv_max_depreciation_unit = [];
        this.ad_hoc_charges = [new QuoteChargeMasterError()];
    }
}

export class EmptyRepoQuoteItemError {
    id: string[];
    requirement: string[];
    quantity: string[];
    updated_at: string[];
    is_active: string[];
    created_by: string[];
    quote: string[];
    container_size_type: string[];
    container_condition: string[];
    pol_list: string[];
    pod_list: string[];
    ad_hoc_charges: QuoteChargeMasterError[];
    charges: EmptyRepoQuoteChargeMasterError[];

    constructor() {
        this.id = [];
        this.requirement = [];
        this.quantity = [];
        this.updated_at = [];
        this.is_active = [];
        this.created_by = [];
        this.quote = [];
        this.container_size_type = [];
        this.container_condition = [];
        this.pol_list = [];
        this.pod_list = [];
        this.ad_hoc_charges = [new QuoteChargeMasterError()];
        this.charges = [new EmptyRepoQuoteChargeMasterError()];
    }
}

export class LeaseQuoteError {
    id: string[];
    request: string[];
    quote_items: LeaseQuoteItemError[];
    quote_valid_till: string[];
    document: string[];
    uploaded_documents: string[];
    remarks: string[];
    quote_number: string[];
    created_by: string[];
    lease_agreement: LeaseAgreementError;
    pickup_schedules: PickupScheduleError[];
    dropoff_schedules: DropoffScheduleError[];
    terms_and_condition_fk: string[];
    terms_and_condition_text: string[];
    agreement: string[];
    ad_hoc_charges: QuoteChargeMasterError[];

    constructor() {
        this.id = [];
        this.request = [];
        this.quote_items = [new LeaseQuoteItemError()];
        this.quote_valid_till = [];
        this.document = [];
        this.uploaded_documents = [];
        this.remarks = [];
        this.quote_number = [];
        this.created_by = [];
        this.lease_agreement = new LeaseAgreementError();
        this.pickup_schedules = [new PickupScheduleError()];
        this.dropoff_schedules = [new DropoffScheduleError()];
        this.agreement = [];
        this.terms_and_condition_fk = [];
        this.terms_and_condition_text = [];
        this.ad_hoc_charges = [new QuoteChargeMasterError()];
    }
}

export class EmptyRepoQuoteError {
    id: string[];
    request: string[];
    quote_items: EmptyRepoQuoteItemError[];
    quote_valid_till: string[];
    document: string[];
    uploaded_documents: string[];
    remarks: string[];
    quote_number: string[];
    created_by: string[];
    pickup_schedules: PickupScheduleError[];
    dropoff_schedules: DropoffScheduleError[];
    terms_and_condition_fk: string[];
    terms_and_condition_text: string[];
    agreement: string[];
    ad_hoc_charges: QuoteChargeMasterError[];
    charges: EmptyRepoQuoteChargeMasterError[];

    constructor() {
        this.id = [];
        this.request = [];
        this.quote_items = [new EmptyRepoQuoteItemError()];
        this.quote_valid_till = [];
        this.document = [];
        this.uploaded_documents = [];
        this.remarks = [];
        this.quote_number = [];
        this.created_by = [];
        this.pickup_schedules = [new PickupScheduleError()];
        this.dropoff_schedules = [new DropoffScheduleError()];
        this.agreement = [];
        this.terms_and_condition_fk = [];
        this.terms_and_condition_text = [];
        this.ad_hoc_charges = [new QuoteChargeMasterError()];
        this.charges = [new EmptyRepoQuoteChargeMasterError()];
    }
}

export class PickupSchedule implements IPickupSchedule {
    id: string;
    port: any;
    client_id: string;
    is_active: boolean;
    per_month_permitted_quantity: number;
    total_permitted_quantity: number;
    handling_charge_currency: string;
    handling_charge: string;
    remarks: string;
    pickup_charge_currency: string;
    pickup_charge: string;
    requirement: any;
    hideRow: string;
    error: PickupScheduleError;

    constructor() {
        this.id = null;
        this.port = null;
        this.client_id = null;
        this.is_active = null;
        this.per_month_permitted_quantity = null;
        this.total_permitted_quantity = null;
        this.handling_charge_currency = null;
        this.handling_charge = null;
        this.remarks = null;
        this.pickup_charge_currency = null;
        this.pickup_charge = null;
        this.requirement = null;
        this.hideRow = null;
        this.error = new PickupScheduleError();
    }
}

export class DropoffSchedule implements IDropoffSchedule {
    id: string;
    port: any;
    client_id: string;
    is_active: boolean;
    per_month_permitted_quantity: number;
    total_permitted_quantity: number;
    handling_charge_currency: string;
    handling_charge: string;
    remarks: string;
    dropoff_charge_currency: string;
    dropoff_charge: string;
    requirement: any;
    hideRow: string;
    error: DropoffScheduleError;

    constructor() {
        this.id = null;
        this.port = null;
        this.client_id = null;
        this.is_active = null;
        this.per_month_permitted_quantity = null;
        this.total_permitted_quantity = null;
        this.handling_charge_currency = null;
        this.handling_charge = null;
        this.remarks = null;
        this.dropoff_charge_currency = null;
        this.dropoff_charge = null;
        this.requirement = null;
        this.hideRow = null;
        this.error = new DropoffScheduleError();
    }
}

export class LeaseAgreement implements ILeaseAgreement {
    id: string;
    terms_and_condition_fk: TermsAndConditionsModel;
    lease_purpose: LeasePurpose;
    documents: Document[];
    is_active: boolean;
    terms_and_condition_text: string;
    lease_type: string;
    billing_cycle: string;
    billing_date: number;
    security_deposit_currency: string;
    security_deposit: string;
    agreement_number: string;
    agreement_starts_from: string;
    agreement_ends_on: string;
    currency: string;
    remarks: string;
    lessor_company_name: string;
    lessor_contact_person_name: string;
    lessor_contact_person_email: string;
    lessor_contact_person_phone: string;
    lessee_company_name: string;
    lessee_contact_person_name: string;
    lessee_contact_person_email: string;
    lessee_contact_person_phone: string;
    lessor_company_address: string;
    lessee_company_address: string;
    request: string;

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.terms_and_condition_fk = data != null ? data.terms_and_condition_fk : null;
        this.lease_purpose = data != null ? data.lease_purpose : null;
        this.documents = data != null ? data.documents : [];
        this.is_active = data != null ? data.is_active : null;
        this.terms_and_condition_text = data != null ? data.terms_and_condition_text : null;
        this.lease_type = data != null ? data.lease_type : null;
        this.billing_cycle = data != null ? data.billing_cycle : null;
        this.billing_date = data != null ? data.billing_date : null;
        this.security_deposit_currency = data != null ? data.security_deposit_currency : null;
        this.security_deposit = data != null ? data.security_deposit : null;
        this.agreement_number = data != null ? data.agreement_number : null;
        this.agreement_starts_from = data != null ? data.agreement_starts_from : null;
        this.agreement_ends_on = data != null ? data.agreement_ends_on : null;
        this.currency = data != null ? data.currency : null;
        this.remarks = data != null ? data.remarks : null;
        this.lessor_company_name = data != null ? data.lessor_company_name : null;
        this.lessor_contact_person_name = data != null ? data.lessor_contact_person_name : null;
        this.lessor_contact_person_email = data != null ? data.lessor_contact_person_email : null;
        this.lessor_contact_person_phone = data != null ? data.lessor_contact_person_phone : null;
        this.lessee_company_name = data != null ? data.lessee_company_name : null;
        this.lessee_contact_person_name = data != null ? data.lessee_contact_person_name : null;
        this.lessee_contact_person_email = data != null ? data.lessee_contact_person_email : null;
        this.lessee_contact_person_phone = data != null ? data.lessee_contact_person_phone : null;
        this.lessor_company_address = data != null ? data.lessor_company_address : null;
        this.lessee_company_address = data != null ? data.id : null;
        this.request = data != null ? data.request : null;

        // this.id = null;
        // this.terms_and_condition_fk = null;
        // this.lease_purpose = null;
        // this.documents = [];
        // this.is_active = null;
        // this.terms_and_condition_text = null;
        // this.lease_type = null;
        // this.billing_cycle = null;
        // this.billing_date = null;
        // this.security_deposit_currency = null;
        // this.security_deposit = null;
        // this.agreement_number = null;
        // this.agreement_starts_from = null;
        // this.agreement_ends_on = null;
        // this.currency = 'USD';
        // this.remarks = null;
        // this.lessor_company_name = null;
        // this.lessor_contact_person_name = null;
        // this.lessor_contact_person_email = null;
        // this.lessor_contact_person_phone = null;
        // this.lessee_company_name = null;
        // this.lessee_contact_person_name = null;
        // this.lessee_contact_person_email = null;
        // this.lessee_contact_person_phone = null;
        // this.lessor_company_address = null;
        // this.lessee_company_address = null;
        // this.request = null;
    }
}

export class Ero implements IEro {
    id: string;
    amount_currency: string;
    amount: number;
    days: number;
    sequence_no: number;
    penalty_from: any;
    fromDays: number;
    toDays: number;

    constructor() {
        this.id = null;
        this.amount_currency = null;
        this.amount = null;
        this.days = null;
        this.sequence_no = null;
        this.penalty_from = null;
        this.toDays = null;
        this.fromDays = null;
    }
}

export class LeaseQuoteItemModel implements ILeaseQuoteItemModel {
    id: string;
    requirement: string;
    quantity: number;
    is_ero_enabled: EarlyReturnOptions | any;
    ero: IEro[];
    updated_at: string;
    is_active: boolean;
    per_diem_charge: number;
    per_diem_charge_currency: string;
    build_up_period_days: number;
    build_down_period_days: number;
    post_build_down_per_diem_charge: number;
    post_build_down_per_diem_charge_currency: string;
    minimum_rental_period_days: number;
    container_deemed_lost_after_days: number;
    notice_period_amendment_delivery_days: number;
    notice_period_amendment_return_days: number;
    leasing_period_days: number;
    created_by: CreatedBy;
    quote: string;
    container_size_type: IContainerSizeType;
    container_condition: IContainerCondition;
    pol_list: LocationModel[];
    pod_list: LocationModel[];
    scheduleLabel?: string;
    drv_new_build_price: number;
    drv_new_build_price_currency: string;
    drv_max_depreciation_price: number;
    drv_max_depreciation_price_currency: string;
    drv_max_depreciation_percent: number;
    drv_depreciation_per_year: number;
    drv_max_depreciation_unit: string;
    ad_hoc_charges?: QuoteChargeMaster[];
    charges?: EmptyRepoQuoteChargeMaster[];

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.requirement = data != null ? data.requirement : null;
        this.quantity = data != null ? data.quantity : null;
        this.is_ero_enabled = data != null ? (data.ero.length != 0 ? {
            code: true,
            value: 'Yes'
        } : {
            code: false,
            value: 'No'
        }) : {
            code: false,
            value: 'No'
        };
        this.ero = data != null ? data.ero : [];
        this.updated_at = data != null ? data.updated_at : null;
        this.is_active = data != null ? data.is_active : null;
        this.per_diem_charge = data != null ? data.per_diem_charge : null;
        this.per_diem_charge_currency = data != null ? data.per_diem_charge_currency : null;
        this.build_up_period_days = data != null ? data.build_up_period_days : null;
        this.build_down_period_days = data != null ? data.build_down_period_days : null;
        this.post_build_down_per_diem_charge = data != null ? data.post_build_down_per_diem_charge : null;
        this.post_build_down_per_diem_charge_currency = data != null ? data.post_build_down_per_diem_charge_currency : null;
        this.minimum_rental_period_days = data != null ? data.minimum_rental_period_days : null;
        this.container_deemed_lost_after_days = data != null ? data.container_deemed_lost_after_days : null;
        this.notice_period_amendment_delivery_days = data != null ? data.notice_period_amendment_delivery_days : null;
        this.notice_period_amendment_return_days = data != null ? data.notice_period_amendment_return_days : null;
        this.drv_new_build_price = data != null ? data.drv_new_build_price : null;
        this.drv_new_build_price_currency = data != null ? data.drv_new_build_price_currency : null;
        this.drv_max_depreciation_price = data != null ? data.drv_max_depreciation_price : null;
        this.drv_max_depreciation_price_currency = data != null ? data.drv_max_depreciation_price_currency : 'USD';
        this.drv_max_depreciation_unit = data != null ? data.drv_max_depreciation_unit : 'price';
        this.drv_depreciation_per_year = data != null ? data.drv_depreciation_per_year : null;
        this.drv_max_depreciation_percent = data != null ? data.drv_max_depreciation_percent : null;
        this.leasing_period_days = data != null ? data.leasing_period_days : null;
        this.created_by = data != null ? data.created_by : null;
        this.quote = data != null ? data.quote : null;
        this.container_size_type = data != null ? data.container_size_type : new ContainerSizeType();
        this.container_condition = data != null ? data.container_condition : new ContainerCondition();
        this.pol_list = data != null ? data.pol_list : [];
        this.pod_list = data != null ? data.pod_list : [];
        this.scheduleLabel = data != null ? data.scheduleLabel : null;
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];
    }

    saveFirstPayload(data) {
        this.requirement = data.id;
        this.quantity = data.quantity;
        this.per_diem_charge = data.per_diem;
        this.per_diem_charge_currency = data.per_diem_currency;
        this.container_size_type = data.container_size_type;
        this.container_condition = data.condition;
        this.leasing_period_days = data.leasing_period_days;
    }

    saveLeaseCommercialPayload() {
        return {
            requirement: this.requirement,
            quantity: this.quantity,
            is_ero_enabled: this.is_ero_enabled,
            ero: this.ero,
            per_diem_charge: this.per_diem_charge,
            per_diem_charge_currency: this.per_diem_charge_currency,
            build_up_period_days: this.build_up_period_days,
            build_down_period_days: this.build_down_period_days,
            post_build_down_per_diem_charge: this.post_build_down_per_diem_charge,
            post_build_down_per_diem_charge_currency: this.post_build_down_per_diem_charge_currency,
            minimum_rental_period_days: this.minimum_rental_period_days,
            container_deemed_lost_after_days: this.container_deemed_lost_after_days,
            notice_period_amendment_delivery_days: this.notice_period_amendment_delivery_days,
            notice_period_amendment_return_days: this.notice_period_amendment_return_days,
            leasing_period_days: this.leasing_period_days,
            quote: this.quote,
            pol_list: this.pol_list.map((item) => item.id),
            pod_list: this.pod_list.map((item) => item.id),
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            container_condition: typeof this.container_condition == 'object' && this.container_condition != null ? this.container_condition.id : this.container_condition,
            drv_new_build_price: this.drv_new_build_price,
            drv_new_build_price_currency: this.drv_new_build_price_currency,
            drv_max_depreciation_price: this.drv_max_depreciation_unit == 'price' ? this.drv_max_depreciation_price : null,
            drv_max_depreciation_price_currency: this.drv_max_depreciation_unit == 'price' ? this.drv_max_depreciation_price_currency : null,
            drv_max_depreciation_percent: this.drv_max_depreciation_unit == 'percent' ? this.drv_max_depreciation_percent : null,
            drv_depreciation_per_year: this.drv_depreciation_per_year,
            drv_max_depreciation_unit: this.drv_max_depreciation_unit,
            ad_hoc_charges: this.ad_hoc_charges,
        }
    }
}

export interface IEmptyRepoQuoteItemModel extends IBaseQuoteItem {
    updated_at: string;
    is_active: boolean;
    pol_list: LocationModel[];
    pod_list: LocationModel[];
}

export class EmptyRepoQuoteItemModel implements IEmptyRepoQuoteItemModel {
    id: string;
    requirement: string;
    quantity: number;
    updated_at: string;
    is_active: boolean;
    created_by: CreatedBy;
    quote: string;
    container_size_type: IContainerSizeType;
    container_condition: IContainerCondition;
    pol_list: LocationModel[];
    pod_list: LocationModel[];
    payee: string;
    inland_haulage: boolean;
    charges?: EmptyRepoQuoteChargeMaster[] | any[];
    ad_hoc_charges?: EmptyRepoQuoteChargeMaster[] | any[];

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.requirement = data != null ? data.requirement : null;
        this.quantity = data != null ? data.quantity : null;
        this.updated_at = data != null ? data.updated_at : null;
        this.is_active = data != null ? data.is_active : null;
        this.created_by = data != null ? data.created_by : null;
        this.quote = data != null ? data.quote : null;
        this.container_size_type = data != null ? data.container_size_type : new ContainerSizeType();
        this.container_condition = data != null ? data.container_condition : new ContainerCondition();
        this.pol_list = data != null ? data.pol_list : [];
        this.pod_list = data != null ? data.pod_list : [];
        this.payee = data != null ? data.payee : null;
        this.inland_haulage = data != null ? data.inland_haulage : false;
        this.charges = data != null ? data.charges : [];
    }

    saveFirstPayload(data) {
        this.requirement = data.id;
        this.quantity = data.quantity;
        this.container_size_type = data.container_size_type;
        this.container_condition = data.condition;
    }

    saveEmptyRepoCommercialPayload() {
        return {
            requirement: this.requirement,
            quantity: this.quantity,
            quote: this.quote,
            pol_list: this.pol_list.map((item) => item.id),
            pod_list: this.pod_list.map((item) => item.id),
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            container_condition: typeof this.container_condition == 'object' && this.container_condition != null ? this.container_condition.id : this.container_condition,
            payee: this.payee,
            inland_haulage: this.inland_haulage,
            charges: this.charges
        }
    }
}

export class LeaseQuoteModel implements ILeaseQuoteModel {
    id: string;
    request: string;
    quote_items: LeaseQuoteItemModel[];
    quote_valid_till: Date;
    document: UploadedDocument;
    uploaded_documents: UploadedDocument[];
    remarks: string;
    quote_number: string;
    created_by: CreatedBy;
    lease_agreement: ILeaseAgreement;
    pickup_schedules: IPickupSchedule[];
    dropoff_schedules: IDropoffSchedule[];
    terms_and_condition_text: string;
    terms_and_condition_fk: TermsAndConditionsModel;
    ad_hoc_charges: QuoteChargeMaster[];

    error: LeaseQuoteError;

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.request = data != null ? data.request : null;
        this.quote_items = data != null ? data.quote_items : [new LeaseQuoteItemModel()];
        let quote_valid_till = new Date();
        quote_valid_till.setDate(quote_valid_till.getDate() + 14);
        this.quote_valid_till = data != null ? data.quote_valid_till : quote_valid_till;
        this.document = data != null ? data.document : null;
        this.uploaded_documents = data != null ? data.uploaded_documents : [];
        this.remarks = data != null ? data.remarks : null;
        this.quote_number = data != null ? data.quote_number : null;
        this.created_by = data != null ? data.created_by : null;
        this.lease_agreement = data != null ? new LeaseAgreement() : null;
        this.pickup_schedules = data != null ? data.pickup_schedules : [];
        this.dropoff_schedules = data != null ? data.dropoff_schedules : [];
        this.terms_and_condition_text = data != null ? data.terms_and_condition_text : null;
        this.terms_and_condition_fk = data != null ? data.terms_and_condition_fk : null;
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];
        this.error = new LeaseQuoteError();

        if (data != null && data.quote_items.length != 0) {
            for (let i = 0; i < data.quote_items.length; i++) {
                this.quote_items[i] = new LeaseQuoteItemModel(data.quote_items[i]);
                this.error.quote_items[i] = new LeaseQuoteItemError();
            }
        } else {
            this.quote_items = [new LeaseQuoteItemModel()];
        }

        if (data != null && data.lease_agreement.length != 0) {
            this.lease_agreement = new LeaseAgreement(data.lease_agreement);
            this.error.lease_agreement = new LeaseAgreementError();
        } else {
            this.quote_items = [new LeaseQuoteItemModel()];
        }
    }

    patchErrors(errors) {
        if (errors.quote_items?.length != 0) {
            for (let i = 0; i < errors.quote_items?.length; i++) {
                this.error.quote_items[i] = errors.quote_items[i];
            }
        }

        this.error.lease_agreement = errors != null && errors.lease_agreement ? errors.lease_agreement : new LeaseAgreementError();
        this.error.quote_valid_till = errors != null && errors.quote_valid_till ? errors.quote_valid_till : [];
        this.error.ad_hoc_charges = errors != null && errors.ad_hoc_charges ? errors.ad_hoc_charges : [new QuoteChargeMasterError()];
        this.error.uploaded_documents = errors != null && errors.uploaded_documents ? errors.uploaded_documents : [];
        this.error.remarks = errors != null && errors.remarks ? errors.remarks : [];
        this.error.agreement = errors != null && errors.agreement ? errors.agreement : [];
        this.error.terms_and_condition_text = errors != null && errors.terms_and_condition_text ? errors.terms_and_condition_text : [];
        this.error.terms_and_condition_fk = errors != null && errors.terms_and_condition_fk ? errors.terms_and_condition_fk : [];

    }


    getLeaseQuotePayload() {
        return {
            request: this.request,
            quote_items: this.quote_items.map(item => item.saveLeaseCommercialPayload()),
            quote_valid_till: this.quote_valid_till,
            document: this.document,
            uploaded_documents: this.uploaded_documents.map((item) => item.id),
            remarks: this.remarks,
            quote_number: this.quote_number,
            created_by: this.created_by,
            lease_agreement: this.lease_agreement,
            pickup_schedules: this.pickup_schedules,
            dropoff_schedules: this.dropoff_schedules,
            ad_hoc_charges: this.ad_hoc_charges,
            terms_and_condition_text: this.terms_and_condition_text,
            terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
        }
    }
}

export interface EarlyReturnOptions {
    code: boolean;
    value: string
}

export class EmptyRepoQuoteModel {
    id: string;
    request: string;
    quote_items: EmptyRepoQuoteItemModel[];
    quote_valid_till: Date;
    document: UploadedDocument;
    uploaded_documents: UploadedDocument[];
    remarks: string;
    quote_number: string;
    created_by: CreatedBy;
    pickup_schedules: IPickupSchedule[];
    dropoff_schedules: IDropoffSchedule[];
    terms_and_condition_text: string;
    terms_and_condition_fk: TermsAndConditionsModel;
    ad_hoc_charges: QuoteChargeMaster[];
    error: EmptyRepoQuoteError;

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.request = data != null ? data.request : null;
        this.quote_items = data != null ? data.quote_items : [new EmptyRepoQuoteItemModel()];
        let quote_valid_till = new Date();
        quote_valid_till.setDate(quote_valid_till.getDate() + 14);
        this.quote_valid_till = data != null ? data.quote_valid_till : quote_valid_till;
        this.document = data != null ? data.document : null;
        this.uploaded_documents = data != null ? data.uploaded_documents : [];
        this.remarks = data != null ? data.remarks : null;
        this.quote_number = data != null ? data.quote_number : null;
        this.created_by = data != null ? data.created_by : null;
        this.pickup_schedules = data != null ? data.pickup_schedules : [];
        this.dropoff_schedules = data != null ? data.dropoff_schedules : [];
        this.terms_and_condition_text = data != null ? data.terms_and_condition_text : null;
        this.terms_and_condition_fk = data != null ? data.terms_and_condition_fk : null;
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];
        this.error = new EmptyRepoQuoteError();

        if (data != null && data.quote_items.length != 0) {
            for (let i = 0; i < data.quote_items.length; i++) {
                this.quote_items[i] = new EmptyRepoQuoteItemModel(data.quote_items[i]);
                this.error.quote_items[i] = new EmptyRepoQuoteItemError();
            }
        } else {
            this.quote_items = [new EmptyRepoQuoteItemModel()];
        }
    }

    patchErrors(errors) {
        if (errors.quote_items?.length != 0) {
            for (let i = 0; i < errors.quote_items?.length; i++) {
                this.error.quote_items[i] = errors.quote_items[i];
            }
        }

        this.error.quote_valid_till = errors != null && errors.quote_valid_till ? errors.quote_valid_till : [];
        this.error.ad_hoc_charges = errors != null && errors.ad_hoc_charges ? errors.ad_hoc_charges : [new QuoteChargeMasterError()];
        this.error.uploaded_documents = errors != null && errors.uploaded_documents ? errors.uploaded_documents : [];
        this.error.remarks = errors != null && errors.remarks ? errors.remarks : [];
        this.error.agreement = errors != null && errors.agreement ? errors.agreement : [];
        this.error.terms_and_condition_text = errors != null && errors.terms_and_condition_text ? errors.terms_and_condition_text : [];
        this.error.terms_and_condition_fk = errors != null && errors.terms_and_condition_fk ? errors.terms_and_condition_fk : [];

    }

    getEmptyRepoQuotePayload() {
        return {
            request: this.request,
            quote_items: this.quote_items.map(item => item.saveEmptyRepoCommercialPayload()),
            quote_valid_till: this.quote_valid_till,
            document: this.document,
            uploaded_documents: this.uploaded_documents.map((item) => item.id),
            remarks: this.remarks,
            quote_number: this.quote_number,
            created_by: this.created_by,
            pickup_schedules: this.pickup_schedules,
            dropoff_schedules: this.dropoff_schedules,
            ad_hoc_charges: this.ad_hoc_charges,
            terms_and_condition_text: this.terms_and_condition_text,
            terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
        }
    }
}

export class EmptyRepoCharges {
    charge_name: string;
    rec_amount: number;
    rec_currency: string;
    pay_amount: number;
    pay_currency: string;
    paid_to: string;

    constructor() {
        this.charge_name = null;
        this.rec_amount = null;
        this.rec_currency = null;
        this.pay_amount = null;
        this.pay_currency = null;
        this.paid_to = null;
    }
}

export class EmptyRepoRequirements {
    requirement: string;
    rec_amount: number;
    rec_amount_currency: string;
    pay_amount: number;
    pay_currency: string;

    constructor() {
        this.requirement = null;
        this.rec_amount = null;
        this.rec_amount_currency = null;
        this.pay_amount = null;
        this.pay_currency = null;
    }
}
